import { render, staticRenderFns } from "./DamNormal.vue?vue&type=template&id=96adceae&scoped=true&"
import script from "./DamNormal.vue?vue&type=script&lang=js&"
export * from "./DamNormal.vue?vue&type=script&lang=js&"
import style0 from "./DamNormal.vue?vue&type=style&index=0&id=96adceae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96adceae",
  null
  
)

export default component.exports